import React, { useState, useEffect } from 'react';
// import BootstrapTable from "react-bootstrap-table-next";
// import paginationFactory, {
// 	PaginationProvider,
// } from 'react-bootstrap-table2-paginator';
import { ChevronLeftIcon, ChevronRightIcon } from '@primer/octicons-react';
import { Row, Col } from 'react-bootstrap';
import logoTable from '../../../assets/images/logotable.jpg';
import { useNavigate } from 'react-router-dom';

export default function ClientsTable({ data }) {
	const totalItems = data.length;
	const itemsPerPage = 10;
	const message = page => {
		return (
			(page - 1) * itemsPerPage +
			1 +
			'-' +
			Math.min((page - 1) * itemsPerPage + itemsPerPage, totalItems) +
			' of ' +
			totalItems
		);
	};
	const [currentItems, setCurrentItems] = useState('');
	const [render, setRender] = useState(false);

	useEffect(() => {
		if (!render) {
			setCurrentItems(message(1));
			setRender(true);
		}
	}, [render, data]);
	const navigate = useNavigate();

	const handleNextPage =
		({ page, onPageChange }) =>
		() => {
			const p =
				parseInt(totalItems / itemsPerPage) +
				(totalItems % itemsPerPage > 0 ? 1 : 0);
			if (page < p) {
				setCurrentItems(message(page + 1));
				onPageChange(page + 1);
			}
		};

	const handlePrevPage =
		({ page, onPageChange }) =>
		() => {
			if (page > 1) {
				setCurrentItems(message(page - 1));
				onPageChange(page - 1);
			}
		};
	function logoViewer(cell, row) {
		return (
			<div>
				{row.user.profile_image === null ? (
					<img className='client-table-logo' src={logoTable} alt='logo' />
				) : (
					<img
						className='client-table-logo'
						src={row.user.profile_image}
						alt='logo'
					/>
				)}
			</div>
		);
	}

	function clientDetailsNavigator(cell, row) {
		return (
			<div
				style={{ fontWeight: 'bold', cursor: 'pointer' }}
				onClick={() => navigate(`client-details`, { params: { data: row } })}
			>
				{row.user.fullname}
			</div>
		);
	}

	const options = {
		showTotal: true,
		disablePageTitle: true,
		sizePerPageList: [
			{
				text: '10',
				value: 10,
			},
		],
		custom: true,
		totalSize: data.length,
	};

	const columns = [
		{
			text: "Clients' Name",
			dataField: 'name',
			sort: true,
			style: { 'font-weight': 'bold' },
			formatter: clientDetailsNavigator,
		},
		{
			text: 'Logo',
			dataField: 'user.profile_image',
			headerStyle: { width: '20%' },
			formatter: logoViewer,
		},
	];
	return (
		// <PaginationProvider pagination={paginationFactory(options)}>
		// {({ paginationProps, paginationTableProps }) => (
		<div>
			<Row>
				<Col>
					{/* <BootstrapTable
                className="rounded-lg"
                keyField="id"
                striped
                bordered={false}
                columns={columns}
                data={data}
                {...paginationTableProps}
              /> */}
				</Col>
			</Row>
			<Row>
				<Col md={{ span: 3, offset: 10 }}>
					<div className='btn-group' role='group'>
						<button
							className='p-0 btn btn-outline-secondary'
							// onClick={handlePrevPage(paginationProps)}
						>
							<ChevronLeftIcon size={24} />
						</button>
						<span className='mr-1 ml-1 react-bootstrap-table-pagination-total page-text'>
							{' '}
							{currentItems}{' '}
						</span>
						<button
							className='p-0 btn btn-outline-secondary'
							// onClick={handleNextPage(paginationProps)}
						>
							<ChevronRightIcon size={24} />
						</button>
					</div>
				</Col>
			</Row>
		</div>
		// )}
		/* </PaginationProvider> */
	);
}
